import { useContext, useEffect, useState, useRef, useMemo } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { groupBy, projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw, useTranslate } from '../../lib'
import ExcelJS from 'exceljs';
import '../../styles/settings.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
import ResponsiveTable from '../../components/common/ResponsiveTable/ResponsiveTable'

export default function ListReport(props) {
    const { openReport, openCallReport, downloadPDF, listCall, search, id } = props
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState(false)

    const ref = useRef(null)
    const [call_list, setCallList] = useState([])
    const { t } = useTranslate();

    const isMobile = window.innerWidth <= 850;
    
    // Función para calcular la concurrencia
    const calculateConcurrency = (callList) => {
        // Crear una copia para no mutar la lista original
        const processedList = callList.map(item => ({
            id: item.id,
            project: item.project,
            session_code: item.session_code,
            project_name: item.project_name,
            bussiness_key: item.bussiness_key,
            created_date: item.created_date,
            audio_name: item.audio_name,
            url_audio: item.url_audio,
            time_call: item.time_call,
            evaluations: item.evaluations,
            channel: item.channel,
            concurrency: 1,
            concurrentGroupId: null,
            minimum_passing_score: item.minimum_passing_score,
            short_conversation: item.short_conversation,
            custom_chat: item.custom_chat,
            clientBubbleImage: item.clientBubbleImage,
            agentBubbleImage: item.agentBubbleImage,
            backgroundImage: item.backgroundImage
        }));
        
        // Establecer concurrencia 1 para todos los elementos por defecto
        processedList.forEach(item => {
            item.concurrency = 1;
            item.concurrentGroupId = null; // Para agrupar chats concurrentes
        });
        
        // Procesar solo elementos del canal chat
        const chatItems = processedList.filter(item => item.channel === "chat");
        
        // Generar grupos de concurrencia
        let concurrentGroupCounter = 1;
        
        // Para cada chat, encontrar otros chats simultáneos del mismo agente y proyecto
        chatItems.forEach((currentChat, index) => {
            // Si ya está asignado a un grupo de concurrencia, omitir
            if (currentChat.concurrentGroupId) return;
            
            const currentStartTime = new Date(currentChat.created_date);
            
            // Encontrar chats dentro de ±5 minutos, mismo agente y mismo proyecto
            const concurrentChats = chatItems.filter(otherChat => {
                if (otherChat.id === currentChat.id) return false;
                if (otherChat.concurrentGroupId) return false; // Ya está asignado a otro grupo
                
                const sameAgent = otherChat.bussiness_key === currentChat.bussiness_key;
                const sameProject = otherChat.project_name === currentChat.project_name;
                
                if (!sameAgent || !sameProject) return false;
                
                const otherStartTime = new Date(otherChat.created_date);
                const timeDiffMinutes = Math.abs(currentStartTime - otherStartTime) / (1000 * 60);
                
                return timeDiffMinutes <= 5;
            });
            
            // Si hay chats concurrentes, crear un grupo
            if (concurrentChats.length > 0) {
                const groupId = `concurrent_${concurrentGroupCounter++}`;
                
                // Asignar el chat actual al grupo
                currentChat.concurrency = concurrentChats.length + 1;
                currentChat.concurrentGroupId = groupId;
                
                // Asignar chats concurrentes al mismo grupo
                concurrentChats.forEach(chat => {
                    chat.concurrency = concurrentChats.length + 1;
                    chat.concurrentGroupId = groupId;
                });
            }
        });
        
        // Ordenar la lista para agrupar chats concurrentes
        processedList.sort((a, b) => {
            // Primero ordenar por proyecto
            if (a.project_name !== b.project_name) {
                return a.project_name.localeCompare(b.project_name);
            }
            
            // Luego por grupo de concurrencia (null al final)
            if (a.concurrentGroupId && !b.concurrentGroupId) return -1;
            if (!a.concurrentGroupId && b.concurrentGroupId) return 1;
            if (a.concurrentGroupId && b.concurrentGroupId) {
                if (a.concurrentGroupId !== b.concurrentGroupId) {
                    return a.concurrentGroupId.localeCompare(b.concurrentGroupId);
                }
            }
            
            // Después por agente
            if (a.bussiness_key !== b.bussiness_key) {
                return a.bussiness_key.localeCompare(b.bussiness_key);
            }
            
            // Finalmente por fecha
            return new Date(a.created_date) - new Date(b.created_date);
        });
        
        return processedList;
    };
    
    useEffect(() => {
        if (listCall && listCall.length > 0) {
            const processedCalls = calculateConcurrency(listCall);
            setCallList(processedCalls);
        } else {
            setCallList([]);
        }
    }, [listCall]);

    const groupedCalls = useMemo(() => {
        return Object.entries(groupBy(call_list, 'project_name'));
    }, [call_list]);

    const orderBy = async (column, e) => {
        if (e.target.classList.contains('rotar')) {
            //   getReports(column, 'asc');
        } else {
            //   getReports(column, 'desc');
        }
        e.target.classList.toggle("rotar")
        //setLogs(log)
    }
    
    return (
        <div>
        {groupedCalls.length > 0 ? (
        groupedCalls.map(([project, groupItems]) => {
            return (
                <div key={project} className="elements table-responsive" ref={ref} style={{ width: '100%', backgroundColor: '#F7F7F7', display: 'flex', 
                    flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', width: '100%'}}>
                            <div className='flex items-center'> <div className='title-subreport' style={{textAlign: 'left', width: '100%'}}>
                                {project}
                            </div>
                            <img onClick={()=>{ }} src={'/icons/dashboard-icon.png'} alt="expand" style={{marginLeft: 9,  width: 20, height: 20, cursor: 'pointer' }}  /></div>
                        </div>
                    {!isMobile && (
                    <table className="table-reports  " style={{ width: '100%', marginLeft: 20, backgroundColor: 'white' }}>
                        <thead>
                            <tr>
                                <th> <div className='icos-th'><span>{t('common.id')}</span>  </div></th>
                                <th> <div className='icos-th'><span>{t('common.project')}</span>  </div></th>
                                <th> <div className='icos-th'><span>{t('common.user')}</span>  </div></th>
                                <th> <div className='icos-th'><span>{t('common.date')}</span>  </div></th>
                                <th><div className='icos-th'><span>{t('common.duration')}</span>   </div></th>
                                <th><div className='icos-th'><span>{t('common.score')}</span>  </div></th>
                                <th><div className='icos-th'><span>{t('reports.concurrency')}</span>  </div></th>
                                <th style={{ width: 50 }}> </th>
                                <th style={{ width: 50 }}> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupItems.map((item, index) => {
                                // Determinar si este elemento es parte de un grupo de concurrencia
                                const isPartOfGroup = item.concurrentGroupId !== null;
                                // Determinar si este elemento es el primero de su grupo
                                const isFirstInGroup = isPartOfGroup && 
                                    (index === 0 || groupItems[index - 1].concurrentGroupId !== item.concurrentGroupId);
                                // Determinar si este elemento es el último de su grupo
                                const isLastInGroup = isPartOfGroup && 
                                    (index === groupItems.length - 1 || groupItems[index + 1].concurrentGroupId !== item.concurrentGroupId);
                                
                                // Estilo para elementos concurrentes
                                let rowStyle = { 
                                    color: '#707070', 
                                    borderBottom: '2px solid rgb(247, 247, 247)'
                                };
                                
                                // Añadir estilo para agrupar visualmente las filas concurrentes
                                if (isPartOfGroup) {
                                    // Borde superior para el primer elemento del grupo
                                    if (isFirstInGroup) {
                                        rowStyle.borderTop = '2px solid #4DA6FF';
                                    }
                                    
                                    // Borde inferior para el último elemento del grupo
                                    if (isLastInGroup) {
                                        rowStyle.borderBottom = '2px solid #4DA6FF';
                                    }
                                }
                                
                                return (
                                    <tr key={index} style={rowStyle}>
                                        <td>{item.id}</td>
                                        <td>{item.project_name}</td>
                                        <td>{item.bussiness_key}</td>
                                        <td>{item.created_date.substring(0, 10)}</td>
                                        <td>{item.time_call}</td>
                                        <td>{item.evaluations?.qualification != null ? (item.evaluations?.qualification * 100)?.toFixed(1) : '-'}%</td>
                                        <td>{item.concurrency || 1}</td>
                                        <td style={{backgroundColor: '#F7F7F7'}}>
                                            <img
                                                src={'/icons/view-report-icon.png'}
                                                height="30"
                                                alt="edit"
                                                onClick={() => openCallReport(item)}
                                            />
                                        </td>
                                        <td style={{backgroundColor: '#F7F7F7'}}>
                                            <img
                                                src={'/icons/download-report-pdf-icon.png'}
                                                height="30"
                                                alt="edit"
                                                onClick={() => {
                                                    const dataCall = {
                                                        ...item.evaluations,
                                                        id: item.id,
                                                        ntUser: item.bussiness_key
                                                    };
                                                    
                                                    downloadPDF(dataCall)
                                                    }
                                                }
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    )}

                    {isMobile && (
                        <div className='p-2 w-100'>
                            <ResponsiveTable
                                data={groupItems}
                                headers={[
                                    t("common.id"),
                                    t("common.project"),
                                    t("common.user"),
                                    t("common.date"),
                                    t("common.duration"),
                                    t("common.score"),
                                    t("reports.concurrency"),
                                ]}
                                renderItem={(item) => ({
                                    id: item.id,
                                    project: item.project_name,
                                    user: item.bussiness_key,
                                    date: item.created_date.substring(0, 10),
                                    duration: item.time_call,
                                    score: item.evaluations?.qualification != null
                                        ? `${(item.evaluations.qualification * 100).toFixed(1)}%`
                                        : "-",
                                    concurrency: item.concurrency || 1,
                                })}
                            />
                        </div>    
                        
                    )}

                </div>
            );
        })
        ) : (
            <p style={{textAlign: 'center', fontSize: 12, margin: 20}}>{t('reports.style.noDataGeneral')}</p>
        )}
        </div>
    );
}